import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {Office} from '../../../classes/Office';
import {OfficeService} from '../../../services/office.service';
import {OfficeEditComponent} from '../office-edit/office-edit.component';

@Component({
  selector: 'app-office-list',
  styleUrls: ['./office-list.component.scss'],
  templateUrl: './office-list.component.html',
})
export class OfficeListComponent implements OnInit {

  public offices: Office[];
  public errorMessage: string;
  private currentDialog = null;

  constructor(private officeService: OfficeService,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.updateList();
  }

  private updateList(): void {
    this.officeService.getAll()
      .subscribe({
        next: (response: Office[]) => this.offices = response,
        error: (error) => this.errorMessage = error.error.error
      });
  }

  openEditModal(office: Office): void {
    this.currentDialog = this.modalService.open(OfficeEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-office-edit',
        size: 'md',
        centered: true,
      });

    this.currentDialog.componentInstance.office = office;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedOffice = new Office(result.value);

          this.officeService.addOrEdit(editedOffice).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(office: Office): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete office ' + office.city + ' ' + office.address + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.officeService.delete(office.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }
}
